import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import Services from "@/components/Services";
import Maintenance from "@/components/Maintenance";
import Manifesto from "@/components/Manifesto";
import ServiceAreas from "@/components/ServiceAreas";
import Reviews from "@/components/Reviews";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-[#0F1215] text-[#F4F2EE] min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <Services />
        <Maintenance />
        <Manifesto />
        <ServiceAreas />
        <Reviews />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}
